import React from 'react';
import './PresentationSection.css';

const PresentationSection = () => {
  return (
    <section className="presentation-card">
      <div className="content">
        <div className="text-left">
          <h2>
            We dive into the meticulous details to execute the perfect lighting.
          </h2>
        </div>
        <div className="text-right">
          <p style={{ textAlign: "justify" }}>
            Smartlight offers you a wide range of trusted market-leading products and we enjoy raising the benchmark in terms of energy efficiency of LEDs (greater output for the same input as for other light sources) and the life expectancy of the products
          </p>
          {/* <a href="#" className="read-more">READ MORE</a> */}
        </div>
      </div>
    </section>
  );
};

export default PresentationSection;
